import { Dropdown } from 'react-bootstrap'
import { Link } from 'gatsby'
import React from 'react'

import { SUPPORTED_LANGUAGES, LANGUAGE_INFO } from './language-config'

function TutorialLanguageDropdownItem ({ language, flagCode, link }) {
  return <Dropdown.Item
    key={'key-dropdown-apps'}
    className='p-0'
    as='li'
  >
    <Link to={link}
      className='dropdown-link link-unstyled'
      target='_blank'>
      <div className='d-flex align-items-center px-3 py-2 border-bottom text-shadow-none'>
        {/* <span className={`flag-icon flag-icon-${flagCode}`} /> */}
        <strong>{language}</strong>
      </div>
    </Link>
  </Dropdown.Item>
}

function TutorialLanguageDropdownToggle ({ language }) {
  let { translatedLang } = getLanguageInfo(language)
  return <>
    {/* <span className={`flag-icon flag-icon-${flagCode} mr-1`} /> */}
    <span className='fa fa-globe mr-1' />
    {translatedLang}
  </>
}

function getLinkToTutorial (slug, language) {
  // TODO this may not be the best approach but it currently works
  // build the right path to the tutorial from slug
  let link = ''
  if (language === 'en') {
    link = `/tutorials/${slug}`
  } else {
    link = `/tutorials/${slug}/${language}`
  }

  return link
}

function getLanguageInfo (language) {
  // get the tranlsated language name and the flag code for flag-icon-css
  let { flagCode, translatedLang } = LANGUAGE_INFO.find(lang => lang.key === language)
  return { translatedLang, flagCode }
}

function getLanguageItemData (availableLanguages, slug) {
  let languages = []
  // check if markdown has entry available_languages
  if (availableLanguages !== null && typeof availableLanguages !== 'undefined') {
    languages = availableLanguages.map(language => {
      // check if language is currently supported in frontend
      if (!SUPPORTED_LANGUAGES.includes(language)) return null

      let link = getLinkToTutorial(slug, language)

      // return flag code for flag-icon-css, link to tutorial and translation for language name
      return {
        ...getLanguageInfo(language),
        link: link
      }
    })
      .filter(language => language !== null)
  }

  // return array of all available languages
  return languages
}

export default function TutorialLanguageDropdown ({ currentLanguage, availableLanguages, slug }) {
  // get all necessary data to render dropdown items
  let languageItemData = getLanguageItemData(availableLanguages, slug)

  // dropdown only gets rendered if there is more than one language available
  return languageItemData.length > 1 && <Dropdown
    className={'d-flex justify-content-center'}
  >
    <Dropdown.Toggle
      id='dropdown-apps'
      variant={'white'}
      className='btn-sm mt-3 mt-lg-0 d-flex align-items-center'
      data-toggle='dropdown'
      data-display='static'>
      <TutorialLanguageDropdownToggle
        language={currentLanguage}
      />
    </Dropdown.Toggle>
    <Dropdown.Menu as='ul'
      className='mt-1 p-0 border-0 rounded-0 shadow'
      style={{ minWidth: 'auto' }}
    >
      {
        languageItemData.map((language, index) => {
          return <TutorialLanguageDropdownItem
            key={`lang-item-${index}`}
            language={language.translatedLang}
            flagCode={language.flagCode}
            link={language.link}
          />
        })
      }
    </Dropdown.Menu>
  </Dropdown>
}
